<template>
  <transition name="promo-fade">
    <div v-if="visible" class="promo-popup" @click="close">
      <button class="promo-popup__close" type="button" aria-label="Закрыть">
        &times;
      </button>
      <img class="promo-popup__img" :src="image" alt="Акция 1+1=3" />
    </div>
  </transition>
</template>

<script>
import image from "@/assets/images/promo/promo-1-1-3.jpg";

// Акция «1+1=3» до 18.10.2026 включительно. Показываем один раз на устройство.
const PROMO_UNTIL = new Date("2026-10-19T00:00:00+05:00");
const STORAGE_KEY = "promo-1-1-3-shown";

export default {
  name: "PromoPopup",
  data() {
    return { visible: false, image };
  },
  mounted() {
    if (new Date() >= PROMO_UNTIL) return;
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (e) {
      // приватный режим — просто показываем
    }
    this.timer = setTimeout(() => this.open(), 600);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
    if (this.visible) this.close();
  },
  methods: {
    open() {
      try {
        localStorage.setItem(STORAGE_KEY, "1");
      } catch (e) {
        // ignore
      }
      this.visible = true;
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", this.onKey);
    },
    close() {
      this.visible = false;
      document.body.style.overflow = "";
      document.removeEventListener("keydown", this.onKey);
    },
    onKey(e) {
      if (e.key === "Escape") this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.promo-popup {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.75);
  cursor: pointer;

  &__img {
    display: block;
    max-width: 100%;
    max-height: calc(100vh - 100px);
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    @media (max-width: 767px) {
      border-radius: 12px;
    }
  }

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    color: #000;
    font-size: 28px;
    line-height: 40px;
    cursor: pointer;
  }
}

.promo-fade-enter-active,
.promo-fade-leave-active {
  transition: opacity 0.3s ease;
}

.promo-fade-enter-from,
.promo-fade-leave-to {
  opacity: 0;
}
</style>
